import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-navigation-header',
	templateUrl:'./WaPageContentsNavigationHeaderProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsNavigationHeaderProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsNavigationHeaderProPage
{
	mdContent_394 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsNavigationHeader;
\`\`\``;
	mdContent_395 = `\`\`\`java
new WaPageContentsNavigationHeader<>()
\`\`\``;
}
